/**
 * @generated SignedSource<<9a3b377b26e00895d7f9dc170feab531>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CandidateVacanciesQuery$variables = {
  first?: number | null | undefined;
};
export type CandidateVacanciesQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CandidateVacancies_query">;
};
export type CandidateVacanciesQuery = {
  response: CandidateVacanciesQuery$data;
  variables: CandidateVacanciesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v8 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endCursor",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasNextPage",
    "storageKey": null
  }
],
v9 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfoExtended",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CandidateVacanciesQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "CandidateVacancies_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CandidateVacanciesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Candidate",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "CandidateContextConnection",
            "kind": "LinkedField",
            "name": "contexts",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CandidateContextEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CandidateContextMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "icon",
                                "storageKey": null
                              },
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "description",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CandidateContextAction",
                            "kind": "LinkedField",
                            "name": "actions",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "label",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "type",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "route",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Parameter",
                                "kind": "LinkedField",
                                "name": "params",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "key",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "value",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "CandidateBasicContext",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": (v8/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": "contexts(first:5)"
          },
          {
            "alias": null,
            "args": (v4/*: any*/),
            "filters": [],
            "handle": "connection",
            "key": "CandidateContext_contexts",
            "kind": "LinkedHandle",
            "name": "contexts"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasPendingGroupInterviewRoomChoose",
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "JobPostingConnection",
            "kind": "LinkedField",
            "name": "jobPostingsCandidateApplied",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "count",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "JobPostingEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JobPosting",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "JobExam",
                        "kind": "LinkedField",
                        "name": "jobExamsWithWeight",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasApplied",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v9/*: any*/),
                        "concreteType": "CandidateApplicationConnection",
                        "kind": "LinkedField",
                        "name": "candidateApplications",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CandidateApplicationEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CandidateApplication",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "createdAt",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Candidate",
                                    "kind": "LinkedField",
                                    "name": "candidate",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v10/*: any*/)
                        ],
                        "storageKey": "candidateApplications(first:100)"
                      },
                      {
                        "alias": null,
                        "args": (v9/*: any*/),
                        "filters": [],
                        "handle": "connection",
                        "key": "CandidateVacanciesCard_candidateApplications",
                        "kind": "LinkedHandle",
                        "name": "candidateApplications"
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v1/*: any*/),
            "filters": [],
            "handle": "connection",
            "key": "CandidateVacancies_jobPostingsCandidateApplied",
            "kind": "LinkedHandle",
            "name": "jobPostingsCandidateApplied"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "11740186d03ed6f9cbe8474990f2d125",
    "id": null,
    "metadata": {},
    "name": "CandidateVacanciesQuery",
    "operationKind": "query",
    "text": "query CandidateVacanciesQuery(\n  $first: Int\n) {\n  ...CandidateVacancies_query_3ASum4\n}\n\nfragment CandidateBasicContextActions_context on CandidateBasicContext {\n  name\n  actions {\n    label\n    type\n    route\n    params {\n      key\n      value\n    }\n  }\n}\n\nfragment CandidateBasicContextIcon_context on CandidateBasicContext {\n  metadata {\n    icon\n  }\n}\n\nfragment CandidateBasicContext_context on CandidateBasicContext {\n  ...CandidateBasicContextIcon_context\n  ...CandidateBasicContextActions_context\n  metadata {\n    title\n    description\n  }\n}\n\nfragment CandidateContext_me on Candidate {\n  id\n  name\n  contexts(first: 5) {\n    edges {\n      node {\n        __typename\n        ... on CandidateBasicContext {\n          id\n          ...CandidateBasicContext_context\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment CandidateVacanciesCard_candidate on Candidate {\n  id\n  hasPendingGroupInterviewRoomChoose\n}\n\nfragment CandidateVacanciesCard_jobPosting on JobPosting {\n  id\n  title\n  jobExamsWithWeight {\n    id\n    title\n    hasApplied\n  }\n  candidateApplications(first: 100) {\n    edges {\n      node {\n        id\n        createdAt\n        candidate {\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment CandidateVacancies_query_3ASum4 on Query {\n  me {\n    id\n    ...CandidateContext_me\n    ...CandidateVacanciesCard_candidate\n    jobPostingsCandidateApplied(first: $first) {\n      count\n      edges {\n        node {\n          id\n          ...CandidateVacanciesCard_jobPosting\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dea19c47044776e3f0b85b4841053419";

export default node;
